// extracted by mini-css-extract-plugin
module.exports = {"root":"Snackbar_root__2-ptB","error_icon":"Snackbar_error_icon__hGfOG"};